import React from 'react';
import { cn } from '@/utils/cn';

const BaseContainer = ({
  children,
  width = 340,
  fullHeight = false,
  margin = false,
  className = '',
}: {
  children?: any;
  width?: number | string;
  fullHeight?: boolean;
  margin?: boolean;
  className?: any;
}) => {
  return (
    <div
      className={cn(
        'shrink-0 flex flex-col overflow-hidden',
        fullHeight && 'h-full overflow-y-auto overflow-x-hidden',
        className
      )}
      style={{ width }}
    >
      {children}
    </div>
  );
};

export default BaseContainer;
